import React from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";
import Loader from "../utils/Loader";

interface Props {
    children: string,
    onClick: any,
    loading?: boolean,
}

const Button = ({
                    children,
                    onClick,
                    loading = false,
                }: Props) => {
    return (
        <CustomBtn onClick={onClick}>
            {loading ? <Loader color={Colors.white}/> : children}
        </CustomBtn>
    )
}

export default Button

const CustomBtn = styled.button`
  border: none;
  color: ${Colors.white};
  box-shadow: ${Colors.buttonShadow};
  background: linear-gradient(45deg, ${Colors.lightGreen} 0%, ${Colors.green} 100%);
  padding: .375em 1.5em;
  transition-duration: 200ms;
  border-radius: 2px;
  
  min-height: 36px;
  min-width: 110px;
  
  @media (max-width: 768px) {
    padding: .6em 3em;
  }
  
  &:hover {
    cursor: pointer;
    transition-duration: 200ms;
    box-shadow: ${Colors.buttonHoverShadow};
    opacity: 80%;
  }

  &:focus {
    outline: none;
  }
`
